<template>
  <div class="more-login-entry">
    <div class="dual-link-row">
      <a
        class="link link-left"
        href="javascript:;"
        @click="openScanCodeLogin"
        >{{ letter.v3ScanCodeLogin }}</a
      >
      <span class="line">|</span>
      <a
        class="link link-right"
        href="javascript:;"
        @click="openAccountLogin"
        >{{ letter.v3BindRole }}</a
      >
    </div>
    <AccountLoginPopup
      v-bind:visible.sync="visibleAccountLoginPopup"
    ></AccountLoginPopup>
    <QrcodeLoginPopup
      v-bind:visible.sync="visibleQrCodeLoginPopup"
    ></QrcodeLoginPopup>
  </div>
</template>

<script>
import AccountLoginPopup from '@components/officialTopupNew/login/AccountLoginPopup.vue';
import QrcodeLoginPopup from '@components/officialTopupNew/login/QrcodeLoginPopup.vue';
export default {
  name: 'MoreLoginEntry',
  components: {
    AccountLoginPopup,
    QrcodeLoginPopup
  },
  data() {
    return {
      visibleAccountLoginPopup: false,
      visibleQrCodeLoginPopup: false
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    openScanCodeLogin() {
      this.visibleQrCodeLoginPopup = true;
    },
    openAccountLogin() {
      this.visibleAccountLoginPopup = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/_mixins.scss';

.more-login-entry {
  .dual-link-row {
    display: contents;
    @include dualLinkRowItems;
  }
}
</style>
